import API from "../API";

declare global {
  interface Window {
    rewardful?: any;
    Rewardful?: any;
  }
}

function getRewardfulReferral(): Promise<string | undefined> {
  if (!process.env.REACT_APP_REWARDFUL) return Promise.resolve(undefined);

  return new Promise((resolve) => {
    let resolved = false;
    const done = (value?: string) => {
      if (!resolved) {
        resolved = true;
        resolve(value || undefined);
      }
    };

    try {
      if (typeof window.rewardful === "function") {
        // Ensure the library is fully initialized, then read Rewardful.referral
        window.rewardful("ready", () => {
          try {
            const ref = (window as any).Rewardful?.referral;
            const value = typeof ref === "string" ? ref : ref?.ref || ref?.id || undefined;
            done(value);
          } catch {
            done(undefined);
          }
        });
      }
    } catch {}

    setTimeout(() => done(undefined), 2000);
  });
}

export const generateCheckoutSession = async () => {
  const referral = await getRewardfulReferral();
  const result = await API.post<{ url: string }>(
    `/payments/create-checkout-session`,
    { referral }
  );
  return result.data;
};
